import { enumIn, UserRole, UserRoleSchema } from '@vmspdb/definitions';
import { getEnumOptions } from '../utils/utils';

export const UserEmployeeRoles = [
  UserRole.OWNER,
  UserRole.FIELD_EMPLOYEE,
  UserRole.OFFICE_EMPLOYEE,
  UserRole.MANAGEMENT,
];

// enumIn rather than ===: option values are proto names while UserEmployeeRoles
// holds the numeric enum, so a direct comparison never matches.
export const UserEmployeeRoleOptions = getEnumOptions(UserRoleSchema).filter(
  (item) => enumIn(UserRoleSchema, item.value, UserEmployeeRoles),
);
